export default __webpack_public_path__ + "static/media/8_1.75624982.jpg";